module.exports = __webpack_public_path__ + "static/media/title-ssf2.c8855efd.png";